module.exports = __webpack_public_path__ + "img/shuffle.f3871a4b.svg";